<template>
  <div id="app">
    <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"
    />
    <meta name="apple-mobile-web-app-capable" content="yes"/>
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view/>
  </div>
</template>


<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
// import DevicePixelRatio from '@/views/DevicePixelRatio.js';
export default {
  name: "PCLIST",
  data() {
    return {
      phone: "",
      codeS: "",
      times: "120",
      codeStatus: false,
      pan_CloseNotShow: "",
    };
  },

  mounted() {
    if (this._isMobile()) {
      if (sessionStorage.getItem("user")) {
        setTimeout(() => {
          localStorage.removeItem("user");
          sessionStorage.removeItem("user");
          this.$router.replace("/LoginPhone");
        }, 43200000);
      }
      let users = sessionStorage.getItem("user")
          ? JSON.parse(sessionStorage.getItem("user"))
          : JSON.parse(localStorage.getItem("user"));
      if (users) {
        console.log("我是刷新", window.location.hash);
        this.$router.replace("/Main_menuPhone");
      } else {
        this.$router.replace("/LoginPhone");
      }
    } else {
      if (sessionStorage.getItem("user")) {

        setTimeout(() => {
          localStorage.removeItem("user");
          sessionStorage.removeItem("user");
          this.$router.replace("/");
        }, 43200000);
      }
      let users = sessionStorage.getItem("user")
          ? JSON.parse(sessionStorage.getItem("user"))
          : JSON.parse(localStorage.getItem("user"));
      if (users) {
        console.log("我是刷新", window.location.hash);
        this.$router.replace("/Main_menuComputer");
      } else {
        this.$router.replace("/");
      }
    }
    this.pan_WeiXin();
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    pan_WeiXin() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.$store.state.pan_CloseNotShow = 0
        // alert(this.$store.state.pan_CloseNotShow)
        //return "weixin";
        // alert("提示: 您在使用的浏览器内核版本可能导致浏览异常,请安装Chrome(谷歌浏览器）、Firefox（火狐）浏览器、夸克浏览器、UC浏览器来使用本系统")
      } else {
        this.$store.state.pan_CloseNotShow = 1
        // alert(this.$store.state.pan_CloseNotShow)
      }

    }

  },
  components: {},
};
</script>

<style>
body,
html {
  margin: 0;
  padding: 0;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100vw;
  height: 100vh;
}

#nav {
  padding: 30px;
}

.el-table th {
  user-select: initial !important;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>

